import './bml-main-banner.scss';
const TEMPLATE = `
<section class="main-banner fade-up">
    <div class="banner-container">
        <div class="banner-circle-container"></div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6" data-animate-child>
                    <div class="video-background">
                        <video autoplay muted loop playsinline>
                            <source src="/images/BML_video_main.mp4" type="video/mp4">
                        </video>
                    </div>
                </div>
                <div class="col-lg-6 d-flex flex-column text-center text-lg-start align-items-lg-start">
                    <h1 data-animate-child>
                        Bogomolets
                        Medical
                        Laboratories
                    </h1>
                    <p data-animate-child>
                        Цифрова патоморфологія з гарантованими якістю та термінами досліджень
                    </p>
                    <a class="main-banner-link" href="#contact-form" data-animate-child>
                        Зв'язатися з нами
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
`;

class BmlMainBanner extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
        this.querySelector('.main-banner-link')?.addEventListener('click', (e) => {
            const target = document.getElementById('contact-form');
            if (!target) return;
            e.preventDefault();
            const headerEl = document.querySelector('bml-header');
            const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 80;
            const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
            window.scrollTo({ top, behavior: 'smooth' });
        });
    }
}

customElements.define('bml-main-banner', BmlMainBanner);
